import { useEffect } from 'react';
import type React from 'react';

import { useGoogleOneTapLogin, useSapCyclingProofExperiment } from '#src/app/pages/loginOrSignup/shared/hooks';
import { useFocusFallbackRef } from '#src/app/shared/hooks/focus';

import { LoginOrSignupBanner } from '../components/LoginOrSignupBanner';

import { SapVisitorContent } from './components/SapVisitorContent';
import { StepColumn } from './components/StepColumn';
import { useTrackLoginOrSingupPageView } from './hooks/useTrackLoginOrSingupPageView';

export const LoginOrSignupLayout: React.FC = () => {
	useTrackLoginOrSingupPageView();

	const ref = useFocusFallbackRef();

	const { displayGoogleOneTap } = useGoogleOneTapLogin({});

	const {
		data: { isSapVisitor },
	} = useSapCyclingProofExperiment();

	useEffect(() => {
		displayGoogleOneTap();
	}, [displayGoogleOneTap]);

	return (
		<>
			<LoginOrSignupBanner />
			<div ref={ref}>
				{isSapVisitor ? (
					// a SAP visitor's content owns its own page wrapper, so the treatment can escape the container
					<SapVisitorContent />
				) : (
					/* 60px+1px+40px refers to HEADER_HEIGHT+line+heading margin, but tailwind doesn't support calc with imported constants
					FIXME use a CSS variable maybe? */
					<div className="container min-h-[calc(100vh-101px)]">
						<div className="mx-auto md:w-96">
							<StepColumn />
						</div>
					</div>
				)}
			</div>
		</>
	);
};
